<template>
    <v-dialog v-model="dialog" scrollable persistent max-width="600px">
        <template v-slot:activator="{ on }">
            <div class="text-left">
                <v-btn block tile class="text-left" color="#f7d9cd" v-on="on" style="box-shadow: none;">
                    <span class="primary--text">
                        {{ $t('dap') }}
                        <v-tooltip bottom max-width="500">
                            <template v-slot:activator="{on}">
                                <v-icon v-on="on">mdi-information-outline</v-icon>
                            </template>
                            <span>En este apartado el usuario puede introducir los datos relativos a los impactos ambientales asociados al material de revestimiento. Puede encontrar este tipo de información en la Declaración Ambiental de Producto.</span>
                        </v-tooltip>
                    </span>
                    <v-spacer></v-spacer>
                </v-btn>
            </div>
        </template>
        <v-card class="primary--text">
            <v-card-title class="pt-2 pb-1 pl-2 pr-1 font-weight-bold title primary white--text">
                {{ $t('dap_descrip') }}
                <v-spacer></v-spacer>
                <v-btn icon right @click="cerrar" color="white">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            {{ $t('dap_descrip_eval') }}
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6" v-for="i in [0,1]" :key="i">
                            <impactos-componente
                                v-if="solucionesConstructivas[i].declaracionAmbientalDermis != null"
                                :nombre="titulo(solucionesConstructivas[i])" :impactos="impactos"
                                :impactos-sol-cons="solucionesConstructivas[i].declaracionAmbientalDermis">
                            </impactos-componente>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn color="error" text :disabled="impactos.length == 0" @click="restaurar">
                    {{ $t('restaurar_todo') }}
                </v-btn>
                <v-btn color="secondary" text @click="dialog = false">{{ $t('cerrar') | capitalize }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import {HttpHelper} from "@/comunes/helpers/HttpHelper";
    import ImpactosComponente from "./Componentes/ImpactosComponente";
    import DescripcionesServicio from "../../../../../comunes/servicios/DescripcionesServicio";

    export default {
        name: "DeclaracionAmbientalComponente",
        props: {
            solucionesConstructivas: {type: Array, required: true},
        },
        components: {
            ImpactosComponente
        },
        data: () => ({
            dialog: false,
            impactos: []
        }),
        mounted() {
            this.solucionesConstructivas.forEach((solCons) => {
                if (solCons.declaracionAmbientalDermis == null)
                    solCons.declaracionAmbientalDermis = {};
            });
            this.cargarImpactos();
        },
        watch: {
            solucionesConstructivas: {
                handler() {
                    this.solucionesConstructivas.forEach((solCons) => {
                        if (solCons.declaracionAmbientalDermis == null)
                            solCons.declaracionAmbientalDermis = {};
                    });
                },
                deep: true
            },
        },
        methods: {
            titulo(solCons) {
                return DescripcionesServicio.materialSolCons(solCons);
            },
            cargarImpactos() {
                this.impactos = [];

                HttpHelper.get("impactos").then(data => {
                    this.impactos = data;
                });
            },
            cerrar() {
                this.dialog = false;
            },
            restaurar() {
                this.solucionesConstructivas.forEach((solCons) => {
                    if (solCons.declaracionAmbientalDermis == null)
                        solCons.declaracionAmbientalDermis = {};
                    else if (typeof solCons.declaracionAmbientalDermis.id === "undefined") {
                        solCons.declaracionAmbientalDermis = {};
                    } else {
                        this.impactos.forEach((impacto) => {
                            solCons.declaracionAmbientalDermis[impacto.codigo] = null;
                        });
                    }
                });
            }
        },
    }
</script>

<style scoped>

</style>

<!--@formatter:off-->
<i18n>
    {
    "es": {
    "dap": "DAP",
    "dap_descrip":"Declaración ambiental",
    "guardar":"Guardar",
    "cerrar":"Cerrar",
    "restaurar_todo":"Restaurar todo"
    }
    }
</i18n>
<!--@formatter:on-->